import React, { Component } from 'react';
import TestVehicle from './TestVehicle';
import helperVehicle from '../../helpers/HelperVehicle';
import IconRender from '../std/IconRender';

class TestVehicles extends Component {

	handleVehicleChange(data, index) {
		var list = [];
		for (var key in this.props.data) {
			var occ = this.props.data[key];
			if (key - index === 0) {
				list.push(data);
			} else {
				list.push(occ);
			}
		}
		this.props.onChangeVehicles(list);
	}
	handleVehicleDelete(code) {
		var list = [];
		for (var key in this.props.data) {
			var occ = this.props.data[key];
			if (occ.configurationKey !== code) {
				list.push(occ);
			}
		}
		this.props.onChangeVehicles(list);
	}
	handleVehicleAdd() {
		let list;
		if (this.props.data == null) {
			list = [];
		} else {
			list = [...this.props.data];
		}
		list.push({ configurationKey: helperVehicle.buidVehicleConfigurationKey(list.length * 1), pricing: {} });
		this.props.onChangeVehicles(list);
	}
	handleVehicleCopy(code) {
		var list = this.props.data != null ? [...this.props.data] : [];
		var occCopy = null;
		for (var key in this.props.data) {
			var occ = this.props.data[key];
			if (occ.configurationKey === code) {
				occCopy = { ...occ };
			}
		}
		if (occCopy != null) {
			occCopy.configurationKey = helperVehicle.buidVehicleConfigurationKey(list.length * 1);
			list.push(occCopy);
			this.props.onChangeVehicles(list);
		}
	}

	render() {
		return (
			<div className="row">
				<div className="accordion" id="accordionVehicles">
					{this.props.data && this.props.data.map((occurence, index) => (
						<div className="accordion-item" key={index}>
							<h6 className="accordion-header" id={`headingAccordionVehicles-${index}`} >
								<button className="accordion-button" type="button" data-bs-toggle="collapse"
									data-bs-target={`#collapseAccordionVehicles-${index}`} aria-expanded="false"
									aria-controls={`collapseAccordionVehicles-${index}`}>
									{(occurence.presentation != null && occurence.presentation.longLabel) || occurence.manufacturerCode || occurence.lcdv16Code || occurence.configurationKey}
								</button>
								<button className="btn btn-light" onClick={() => this.handleVehicleDelete(occurence.configurationKey)} >
									<IconRender name="trash" />
								</button>
								<button className="btn btn-light" onClick={() => this.handleVehicleCopy(occurence.configurationKey)} >
									<IconRender name="stickies" />
								</button>
							</h6>
							<div id={`collapseAccordionVehicles-${index}`} className="accordion-collapse collapse"
								aria-labelledby={`headingAccordionVehicles-${index}`}  >
								<div className="accordion-body">
									<TestVehicle data={occurence}
										context={this.props.context}
										settings={this.props.settings}
										onChangeVehicle={(data) => { this.handleVehicleChange(data, index) }}
										disableOptionsAccessories={this.props.disableOptionsAccessories}
									/>
								</div>
							</div>
						</div>
					))}
				</div>
				<div className="col-auto">
					<button className="btn btn-light" onClick={() => this.handleVehicleAdd()} >
						<IconRender name="plus" />
					</button>
				</div>
			</div>
		)
	}
}

export default (TestVehicles)
